export function getAccountBadgeFiltersEssential() {
    return [
        // not include reissued
        { column: 'reissuedByAccountBadgeId', op: 'is-null' },
    ];
}
